<template>
  <div class="list">

    <div class="jumbotron">
      <div class="row px-4 ">
        <div class="col-md-3 h1">{{lang.Search}}</div>
        <div class="col-md-9">
         <input class="form-control shadow" type="text" v-model="filter" v-bind:placeholder="lang.Placeholder" autofocus>
         
         <!-- <div class="form-check mt-3 text-md-right" v-if="filters">
        <label class="checkbox-label">
          <input type="checkbox" class="form-check-input" id="UitgebreidZoeken" v-model="advanced">Uitgebreid zoeken
          <div class="checkbox-check"></div>
        </label>
      </div> -->

    </div>
  </div>

  <div class="px-4" v-if="advanced">
    <hr class="my-4">
    <div class="col-12 col-lg-6 form-check" v-for="item in filters">

     <div class="d-flex align-items-centers">
      <label class="checkbox-label">
        <input type="checkbox" class="checkbox" v-model="selectedTags" :name="item" :value="item" :id="item">{{item}}
        <div class="checkbox-check"></div>
      </label>
    </div>


  </div>



  <div class="form-check mt-3" v-if="selectedTags.length >= 2 ">
    <hr>
    <label class="checkbox-label">
      <input type="checkbox" class="form-check-input" id="withAllTags" v-model="withAllTags">Selectie uitbreiden
      <div class="checkbox-check"></div>
    </label>
  </div>
</div>
</div>


<div class="list-group">

  <div class="row px-4 mb-3">
    <div class="col-12 text-right text-muted">
      {{ filterByAny(users,filter).length }} {{ lang.Results }}
    </div>
  </div>

  <div class="row px-2">
    <a class="col-12 col-md-6 col-lg-4 d-flex col-xl-2 p-3 align-center" v-for=" user in filterByAny(users,filter)" v-bind:href="readurl+user.id">
      <div class="list-group-item list-group-item-action border shadow p-4 d-flex flex-column">
        <div v-if="user.details.foto" class="mr-2 avatar x4" v-bind:style="{ backgroundImage: 'url(/files/download/thumbs/'+ user.details.foto + ')' }"></div>
        <div v-else="! user.foto" class="mr-2 avatar x4" style="backgroundImage: url('/svg/avatar.svg');"></div>
        <div class="mt-2 w-100 text-center">
          {{ user.details.voornaam }} {{ user.details.achternaam }}
          <br>
          <small>{{user.details.telefoon}}</small>
          <br>
        </div>
      </div>
    </a>
  </div>
</div>

</div>
</template>

<script>
  export default {
    props: [
    'readurl',
    ],
    data() {
      return {
        users: [],
        filters: [],
        filter: '',
        advanced: false,
        selectedTags: [],
        withAllTags: false,
        lang: this.translation(),
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      }
    },
    methods: {
     translation: function(){
       var lang 
       
       if (window.lang == "nl") {
        lang = { 
          'Search': "Zoeken",
          'Placeholder': "Begin met typen...",
          'Results': "Resultaten"
        };
      }else{
        lang = { 
          'Search': "Search",
          'Placeholder': "Start typing...",
          'Results': "Results"
        };
      };

      return lang;
    },

    filterByAny: function(list, value) {

      if( ! list ) return [];

      return list.filter(function(item) {
        value = value.toLowerCase()
        var check = false;
        Object.keys(item.details).forEach(function(keyname) {
          if (typeof(item.details[keyname]) == 'string' && item.details[keyname].toLowerCase().indexOf(value.toLowerCase()) > -1) {
            check = true;
          }
        })
        if (check === true) {
          return true;
        }
      });
    },

    loadUsers: function(){
      axios.post( '/endpoint/userdata', {'_token' : this.csrf    } ).then(function(data) {
        console.log('data', data.data);
        this.users = data.data.users
        this.filters = data.data.filters
      }.bind(this))
    },

    filterUsers: function( selection ){

      var params = {
        '_token' : this.csrf,  
        'selectedTags' : this.selectedTags,
        'withAllTags': this.withAllTags
      }
      axios.post( '/endpoint/userdata', params ).then(function(data) {
      // console.log('data', data.data);
      this.users = data.data.users
      // console.log(data.data.tags);
    }.bind(this)).catch(function (error) {
    // handle error
    console.log(error);
  })
  }
},
watch: {
  selectedTags(){
    this.filterUsers();
  },
  withAllTags(){
    this.filterUsers();
  },
  advanced(value){
    if( value === false ){
      this.selectedTags = [];
      this.withAllTags = false;
    }
  }
},
mounted: function() {
  this.loadUsers();
}};

</script>



// WEBPACK FOOTER //
// resources/js/components/UserIndex.vue